import React, { useEffect, useState } from 'react'
import productServices from '../../services/ProductsServices'
import Loading from '../feedback/Loading'
import FetchError from '../feedback/FetchError'
import Empty from '../feedback/Empty'
import moment from 'moment'
import { BiSolidAddToQueue } from "react-icons/bi";
import ProductBrandModal from './ProductBrandModal'

function BrandsList() {
    const [brands, setBrands] = useState()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState()
    const [action, setAction] = useState(0)
    const [activeBrand, setActiveBrand] = useState()

    useEffect(() => {
        getBrands()
    }, [])

    const getBrands = () => {
        setError()
        productServices.getBrands().then(
            res => {
                setBrands(res.data)
                setLoading(false)
            },
            err => {
                console.log(err);
                setError(err)
                setLoading(false)
            }
        )
    }

    function openModal(action, brand) {
        const openBtn = document.getElementById("product-brand-open-btn")
        if (action === 0) {
            setAction(0)
        }
        if (action === 1) {
            setActiveBrand(brand)
            setAction(1)
        }
        openBtn.click()
    }
    return (
        <details className="collapse collapse-arrow bg-white dark:bg-slate-800 rounded-lg shadow-sm overflow-hidden border border-border-light dark:border-border-dark">
            <summary className="collapse-title font-semibold">Brand List <span className='ml-3 text-gray-600'>{"("}{brands?.length || 0}{")"}</span></summary>
            <div className="collapse-content border-t pt-3">
                {loading ? (
                    <div className="py-10">
                        <Loading />
                    </div>
                ) : (
                    <>
                        {error ? (<FetchError error={error} />) : (
                            <div className=''>
                                <ProductBrandModal
                                    action={action}
                                    activeBrand={activeBrand}
                                    getBrands={getBrands}
                                />
                                <div className='mb-3'>
                                    <div className="flex justify-end">
                                        <button
                                            onClick={() => openModal(0)}
                                            className='btn btn-primary btn-sm'><BiSolidAddToQueue className='h-4 w-4 mr-2' /> Add Brand</button>
                                    </div>
                                    {brands?.length ? (
                                        <div className='overflow-x-auto mt-3'>
                                            <table className="table table-compact table-zebra w-full">
                                                <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Products</th>
                                                        <th>Models</th>
                                                        <th className='hidden md:table-cell'>Created</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {brands?.map((brand, idx) => (
                                                        <tr
                                                            key={idx}>
                                                            <td className='font-bold'>
                                                                {brand?.name}
                                                            </td>
                                                            <td>
                                                                {brand?.product_count}
                                                            </td>
                                                            <td>
                                                                {brand?.model_count}
                                                            </td>
                                                            <td className='hidden md:table-cell'>
                                                                {moment(brand?.creation_time).format("MMM Do YYYY")}
                                                            </td>
                                                            <td>
                                                                <button
                                                                    onClick={() => openModal(1, brand)}
                                                                    className='btn btn-sm btn-primary'>View</button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <Empty objectName={"Brands"} />
                                    )}
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </details>
    )
}

export default BrandsList